import Component from '@glimmer/component';

import DateRangeError from 'rise-ui/components/date-range-error.gjs';
import DateRangeWarning from 'rise-ui/components/date-range-warning.gjs';
import Date from 'rise-ui/components/time-series/selection/output/actions/date.gjs';
import and from 'rise-ui/helpers/and.js';
import dateUnbound from 'rise-ui/helpers/date-unbound.js';
import datePartlyUnbound from 'rise-ui/helpers/date-partly-unbound.js';
import ifElse from 'rise-ui/helpers/if-else.js';
import not from 'rise-ui/helpers/not.js';
import or from 'rise-ui/helpers/or.js';
import qpDateInverted from 'rise-ui/helpers/qp-date-inverted.js';
import qpDateUnfilled from 'rise-ui/helpers/qp-date-unfilled.js';

export default class TimeSeriesSelectionOutputActionsDatesComponent extends Component {
  <template>
    {{#let
      (and @datesRequired (qpDateUnfilled @dateRanges skip="to"))
      (and @datesRequired (qpDateUnfilled @dateRanges skip="from"))
      (and @datesRequired (qpDateInverted @dateRanges))
      (dateUnbound @availableDates.from @availableDates.to @dateRanges)
      (datePartlyUnbound @availableDates.from @availableDates.to @dateRanges skip="to")
      (datePartlyUnbound @availableDates.from @availableDates.to @dateRanges skip="from")
      as | isFromEmpty isToEmpty isInverted isUnbound isFromPartlyUnbound isToPartlyUnbound |}}
    {{#let
      (and isFromEmpty isToEmpty)
      (and isFromPartlyUnbound isToPartlyUnbound)
      (or isInverted isUnbound)
      as | isEmpty isDateRangeWide hasBothDatesError |
    }}
    {{#let
      (and
        @datesRequired
        (not (or hasBothDatesError isFromPartlyUnbound isToPartlyUnbound isFromEmpty isToEmpty))
      )
      (or hasBothDatesError isFromEmpty)
      (or hasBothDatesError isToEmpty)
      as | isValid isFromError isToError |
    }}
      <span class="c-time-series-selection-line__dates">
        <Date
          @fromState={{ifElse
            isFromError "error"
            isFromPartlyUnbound "warning"
            @datesRequired "valid"
          }}
          @toState={{ifElse
            isToError "error"
            isToPartlyUnbound "warning"
            @datesRequired "valid"
          }}
          @allOption={{true}} @dateRanges={{@dateRanges}}
          @onDatesChange={{@onDatesChange}}
          @linkToClear={{@linkToClear}}
          @linkToCopy={{@linkToCopy}}
          @linkToWeek={{@linkToWeek}}
          @linkToMonth={{@linkToMonth}}
          @linkToYear={{@linkToYear}}
          @linkTo10Years={{@linkTo10Years}}
          @linkToAll={{@linkToAll}}
          @onDropdownSelection={{@onDropdownSelection}}
        />
        {{#if @datesRequired}}
          {{#if isEmpty}}
            <DateRangeError
              class="qa-missing-dates"
              title="Output cannot be generated due to a missing date range."
            >
              Date range required
            </DateRangeError>
          {{else if isFromEmpty}}
            <DateRangeError
              class="qa-missing-start-date"
              title="Output cannot be generated due to a missing start date."
            >
              Start date required
            </DateRangeError>
          {{else if isToEmpty}}
            <DateRangeError
              class="qa-missing-end-date"
              title="Output cannot be generated due to a missing end date."
            >
              End date required
            </DateRangeError>
          {{else if isInverted}}
            <DateRangeError
              class="qa-inverted-dates"
              title="Output cannot be generated due to end date earlier than start date."
            >
              Date range inverted
            </DateRangeError>
          {{else if isUnbound}}
            <DateRangeError
              class="qa-outside-dates"
              title="Output cannot be generated due to dates completely outside available date range."
            >
              Dates out of range
            </DateRangeError>
          {{else if isDateRangeWide}}
            <DateRangeWarning class="qa-wide-dates">
              Includes dates out of range
            </DateRangeWarning>
          {{else if isFromPartlyUnbound}}
            <DateRangeWarning class="qa-late-dates">
              Start date out of range
            </DateRangeWarning>
          {{else if isToPartlyUnbound}}
            <DateRangeWarning class="qa-early-dates">
              End date out of range
            </DateRangeWarning>
          {{/if}}
        {{/if}}
      </span>
    {{/let}}
    {{/let}}
    {{/let}}
  </template>
}
